import { sh } from '@tpluscode/rdf-ns-builders/loose';
import { isBlankNode, isGraphPointer } from 'is-graph-pointer';
import NodeExpressionImpl from './NodeExpression.js';
import { getOne, getOneOrZero } from './util.js';
export class CountExpression extends NodeExpressionImpl {
    static match(pointer) {
        return isBlankNode(pointer) && isGraphPointer(getOneOrZero(pointer, sh.count));
    }
    static fromPointer(pointer, createExpr) {
        return new CountExpression(pointer.term, createExpr.nodeExpression(getOne(pointer, sh.count)));
    }
    get requiresFullContext() {
        return this.expression.requiresFullContext;
    }
    get rootIsFocusNode() {
        return this.expression.rootIsFocusNode;
    }
    constructor(term, expression) {
        super();
        this.term = term;
        this.expression = expression;
    }
    _buildPatterns({ subject, variable, object, rootPatterns }, builder) {
        const where = builder.build(this.expression, {
            subject,
            variable,
            rootPatterns,
        });
        return {
            type: 'query',
            queryType: 'SELECT',
            prefixes: {},
            variables: [{
                    variable: object,
                    expression: {
                        type: 'aggregate',
                        aggregation: 'count',
                        expression: where.object,
                    },
                }],
            where: where.patterns,
        };
    }
}
